module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/bergamo.189e4467316cba1bca828c4fc8025b0e.jpg";